export default __webpack_public_path__ + "static/media/hdb-construction-2.58af56ac.svg";